import { useCallback, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export const FALLBACK_STORAGE_NAME = "STORAGE_FALLBACK_NAVIGATION";
export function useCustomNavigate() {
  const navigate = useNavigate();
  const location = useLocation();

  const parserStorage = (value: string | null) => {
    if (!value) return { pathList: ["/"] };
    try {
      return JSON.parse(value) as { pathList: string[] };
    } catch {
      return { pathList: ["/"] };
    }
  };

  const getStorageData = useCallback(() => {
    const storagedPath = sessionStorage.getItem(FALLBACK_STORAGE_NAME);
    const data = parserStorage(storagedPath);
    return data;
  }, []);

  const setStorageData = useCallback((pathList: string[]) => {
    sessionStorage.setItem(FALLBACK_STORAGE_NAME, JSON.stringify({ pathList }));
  }, []);
  useEffect(() => {
    const { pathList } = getStorageData();
    const namePath = location.pathname;

    if (namePath === "/" && pathList.length > 1) {
      sessionStorage.removeItem(FALLBACK_STORAGE_NAME);
      return;
    }

    if (pathList.length && pathList[pathList.length - 1] !== namePath) {
      const newPathList = [...pathList, namePath];
      setStorageData(newPathList);
    }
  }, [location.pathname, getStorageData, setStorageData]);

  const handleBack = useCallback(() => {
    const { pathList } = getStorageData();
    if (pathList.length === 1) {
      return;
    }
    const previousPath = pathList[pathList.length - 2];
    setStorageData(pathList.slice(0, -1));
    navigate(previousPath, { replace: true });
  }, [navigate, location.pathname, getStorageData, setStorageData]);

  const handleNavigateBack = useCallback(() => {
    if (navigate.length > 0) {
      navigate(-1);
    } else {
      navigate("/");
    }
  }, [navigate]);

  return {
    handleBack,
    navigate,
    setStorageData,
    handleNavigateBack,
  };
}
